<template>
  <v-card flat class="card-analytics-v3">
    <span class="d-flex mb-5">
      <img src="@/assets/live-red.svg" alt="Real Time Icon" class="mr-2" />
      <p class="body-bold-medium neutral-20-dark--text mb-0">
        {{ $t('message.pages.analyticsV3.resume.realTime') }}
      </p>
    </span>
    <ResumeCard :item="cardItem" :loading="loading" compact oneRowLoading />
    <span>
      <base-btn
        type="secondary"
        class="background-btn mt-5"
        size="small"
        @click="handleOpenRealTime"
      >
        {{ $t('message.pages.analyticsV3.resume.openRealTime') }}
        <v-icon size="20" class="ml-1">mdi-arrow-right</v-icon>
      </base-btn>
    </span>
    <RealtimeModal />
  </v-card>
</template>

<script>
import ResumeCard from '../Charts/ResumeCard.vue'
import i18next from 'i18next'
import RealtimeModal from '../../screens/Realtime/index.vue'

export default {
  name: 'RealTimeBanner',
  components: {
    ResumeCard,
    RealtimeModal,
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    realTimeUsers: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    cardItem() {
      return {
        label: this.$t('message.pages.analyticsV3.resume.peopleWatching'),
        tooltip: this.$t(
          'message.pages.analyticsV3.resume.tooltips.peopleWatching'
        ),
        value: this.realTimeUsers.toLocaleString(i18next.language),
      }
    },
  },
  methods: {
    handleOpenRealTime() {
      this.$root.$emit('openRealtimeModal')
    },
  },
}
</script>
